import { useNavigate } from 'react-router-dom'
import { User, Trophy, LogOut } from 'lucide-react'
import { useAuthStore } from '@/stores/auth.store'

export default function GameSelect() {
  const navigate = useNavigate()
  const { user, signOut } = useAuthStore()

  return (
    <main className="min-h-screen bg-arcade-bg flex flex-col text-white">
      {/* Top nav */}
      <header className="border-b border-arcade-border px-6 py-3 flex items-center justify-between">
        <p className="text-xs font-mono text-gray-500 uppercase tracking-widest">CodeArcade</p>
        <div className="flex items-center gap-1">
          <button
            onClick={() => navigate('/leaderboard')}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-gray-400 hover:text-white hover:bg-arcade-surface transition-colors text-xs font-mono"
          >
            <Trophy size={14} />
            Leaderboard
          </button>
          {user && (
            <button
              onClick={() => navigate('/profile')}
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-gray-400 hover:text-white hover:bg-arcade-surface transition-colors text-xs font-mono"
            >
              <User size={14} />
              Profile
            </button>
          )}
          {user && (
            <button
              onClick={() => signOut()}
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-gray-400 hover:text-white hover:bg-arcade-surface transition-colors text-xs font-mono"
            >
              <LogOut size={14} />
              Sign out
            </button>
          )}
        </div>
      </header>

      {/* Quest selection */}
      <div className="flex-1 flex flex-col items-center justify-center gap-6 px-4">
        <h1 className="text-3xl font-mono font-bold text-white">Choose Your Quest</h1>
        <button
          onClick={() => navigate('/play/algoquest')}
          className="px-8 py-4 bg-[#f7c948] hover:bg-yellow-400 text-black font-bold rounded-xl transition-colors text-lg"
        >
          AlgoQuest
        </button>
      </div>
    </main>
  )
}
